const easeInOutQuad = (
  currentTime: number, startValue: number, changeInValue: number, duration: number,
): number => {
  currentTime /= duration / 2

  if (currentTime < 1) {
    return changeInValue / 2 * currentTime * currentTime + startValue
  }

  currentTime--

  return -changeInValue / 2 * (currentTime * (currentTime - 2) - 1) + startValue
}

/**
 * Animation for scrolling
 */
const scrollTo = (
  element: HTMLElement, start: number, to: number, duration: number = 600,
): void => {
  const change = to - start
  let currentTime = 0
  const increment = 20

  const animateScroll = () => {
    currentTime += increment

    element.scrollTop = easeInOutQuad(currentTime, start, change, duration)

    if (currentTime < duration) {
      setTimeout(animateScroll, increment)
    }
  }

  animateScroll()
}

interface ScrollInsideElementProps {
  element: HTMLElement
  isScrollDown?: Boolean
  index?: number
}

/**
 * Scroll at the height of the element
 */
const scrollInsideElement = ({ element, isScrollDown, index }: ScrollInsideElementProps): void => {
  const { clientHeight: elementHeight, scrollHeight: elementScrollHeight, scrollTop } = element

  let top = scrollTop + elementHeight

  if (index) {
    let to = elementHeight * index - elementHeight
    const maxScrollHeight = elementScrollHeight - elementHeight

    if (to < elementHeight) {
      to = 0
    }
    else if (to > maxScrollHeight) {
      to = maxScrollHeight
    }
    scrollTo(element, scrollTop, to)
  }
  else if (isScrollDown && top < elementScrollHeight) {
    let scrollHeight = elementHeight

    if (elementScrollHeight - top < elementHeight) {
      scrollHeight = elementScrollHeight - top
      top = scrollTop + scrollHeight
    }

    scrollTo(element, scrollTop, top)
  }
  else if (!isScrollDown && scrollTop) {
    const height = scrollTop - elementHeight
    const to = height < 0 ? 0 : height

    scrollTo(element, scrollTop, to)
  }
}


export default scrollInsideElement
